var theme = {
  overrides: {
    MuiFormControl: {
      root: {
        marginTop: 20,
        '&:first-child': {
          marginTop: 0
        }
      },
      marginDense: {
        marginTop: 12
      }
    },
    MuiFormControlLabel: {
      label: {
        fontSize: 14
      }
    },
    MuiFormLabel: {
      asterisk: {
        color: '#ff2525',
        fontWeight: 500
      }
    },
    MuiPaper: {
      root: {
        backgroundColor: '#fff',
        border: '1px solid #e2e2e2',
        borderBottom: 0
      }
    },
    MuiTypography: {
      h1: {
        fontSize: 20,
        fontWeight: 400,
        marginBottom: 16
      }
    },
    MuiTableRow: {
      root: {
        height: 40,
        '&:nth-child(2n+1)': {
          backgroundColor: 'rgba(0,0,0,0.03)'
        },
        '&$selected': {
          color: '#fff',
          backgroundColor: '#26A69A !important'
        }
      }
    },
    MuiTableCell: {
      head: {
        backgroundColor: '#fff'
      }
    },
    MuiTab: {
      root: {
        maxWidth: 300
      }
    },
    MuiCheckbox: {
      root: {
        padding: '6px 12px'
      }
    },
    MuiInput: {
      underline: {
        borderBottomColor: '#4DB6AC',
        '&:after': {
          borderBottomColor: '#4DB6AC'
        }
      }
    },
    MuiInputBase: {
      input: {
        '&:-webkit-autofill': {
          transition: 'background-color 5000s ease-in-out 0s',
          '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.87) !important',
          caretColor: 'rgba(0, 0, 0, 0.87) !important'
        },
        '&:-internal-autofill-selected': {
          transition: 'background-color 5000s ease-in-out 0s',
          '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.87) !important',
          caretColor: 'rgba(0, 0, 0, 0.87) !important'
        }
      }
    },
    MuiOutlinedInput: {
      root: {
        '&$disabled': {
          // opacity: 0.5,
          cursor: 'not-allowed'
        }
      },
      input: {
        '&$disabled': {
          // opacity: 0.5
          backgroundColor: '#f4f4f4',
          cursor: 'not-allowed'
        }
      }
    },
    MuiInputLabel: {
      outlined: {
        '&$disabled': {// opacity: 0.5
        }
      }
    },
    PrivateTabIndicator: {
      colorSecondary: {
        backgroundColor: '#4DB6AC'
      }
    }
  },
  palette: {
    background: {
      default: '#fff',
      paper: '#fbfbfd'
    },
    primary: {
      contrastText: '#fff',
      dark: '#00897B',
      light: '#4DB6AC',
      main: '#26A69A'
    },
    secondary: {
      contrastText: '#fff',
      dark: '#212121',
      light: '#9E9E9E',
      main: '#616161'
    }
  },
  typography: {
    htmlFontSize: 16
  }
};
export default theme;